import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IPersonBody } from '../person-body-schema';
import type { IPersonResponse } from '../person-response';
import { personResponseSchema } from '../person-response';

export async function createPersonApi(
  body: IPersonBody,
): Promise<IValidatedResponse<IPersonResponse>> {
  return postRequest<IPersonResponse>({
    path: '/sys/people/v1',
    body,
    schema: personResponseSchema,
  });
}
